const TestimonialRating = () => {
  return (
    <>
      <h2 className="text-30 text-white">
        Co mówią o nas nasi użytkownicy?
      </h2>
      <p className="text-white mt-20">
        Sprawdź w jaki sposób tripsi pomaga im znaleźć najlepsze wakacje!
      </p>

      <div className="row y-gap-30 text-white pt-60 lg:pt-40">
        <div className="col-sm-5 col-6">
          <div className="text-30 lh-15 fw-600">100 000+</div>
          <div className="lh-15">Znalezionych wycieczek</div>
        </div>
        {/* End .col */}

        <div className="col-sm-5 col-6">
          <div className="text-30 lh-15 fw-600">10 000+</div>
          <div className="lh-15">Aktywnych wycieczek w bazie danych</div>
          {/*<div className="d-flex x-gap-5 items-center pt-10">*/}
          {/*  <div className="icon-star text-white text-10" />*/}
          {/*  <div className="icon-star text-white text-10" />*/}
          {/*  <div className="icon-star text-white text-10" />*/}
          {/*  <div className="icon-star text-white text-10" />*/}
          {/*  <div className="icon-star text-white text-10" />*/}
          {/*</div>*/}
        </div>
        {/* End .col */}
      </div>
    </>
  );
};

export default TestimonialRating;
